import { createContext, useContext, useState, ReactNode, useRef } from "react";
import Contact, { ContactDialogRef } from "@/components/Contact";

interface ContactDialogContextType {
  openDialog: () => void;
}

const ContactDialogContext = createContext<ContactDialogContextType | undefined>(undefined);

export const ContactDialogProvider = ({ children }: { children: ReactNode }) => {
  const contactRef = useRef<ContactDialogRef>(null);

  const openDialog = () => {
    contactRef.current?.open();
  };

  return (
    <ContactDialogContext.Provider value={{ openDialog }}>
      {children}
      <Contact ref={contactRef} />
    </ContactDialogContext.Provider>
  );
};

export const useContactDialog = () => {
  const context = useContext(ContactDialogContext);
  if (!context) {
    throw new Error("useContactDialog must be used within ContactDialogProvider");
  }
  return context;
};
